import {Component, OnInit} from '@angular/core';
import { AuthService } from '../../auth/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'cons-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isCollapsed = false;
  user$: Observable<any>;
  showMenu = false;
  showMenuSanPham = false;
  showMenuCongCu = false;
  showMenuHoTro = false;
  listMenus: any[] = [];

  constructor(
    private authService: AuthService,
  ) {
    this.user$ = this.authService.currentUser$;
  }

  ngOnInit(): void {
  }
}
